export const GreenCheckCircle = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00001 0.833008C3.33334 0.833008 0.333344 3.83301 0.333344 7.49967C0.333344 11.1663 3.33334 14.1663 7.00001 14.1663C10.6667 14.1663 13.6667 11.1663 13.6667 7.49967C13.6667 3.83301 10.6667 0.833008 7.00001 0.833008ZM5.66668 10.833L2.33334 7.49967L3.27334 6.55967L5.66668 8.94634L10.7267 3.88634L11.6667 4.83301L5.66668 10.833Z"
        fill="#64FF50"
      />
    </svg>
  );
};

export default GreenCheckCircle;
